import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import TreeList from "./SelectCategoryDialog/TreeList"
import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import Cookie from "../Cookie"
import {config} from "../config"

/**
 * <SelectCategoryDialog parent onSelectCategory = {category} onCancel = {} />
 */

class SelectCategoryDialog extends Component {

	state = {
		categorys: [],
		selected: undefined,
		dialog: undefined,
	}

	constructor(props) {
		super(props)
		this.handleSelectButtonClick = this.handleSelectButtonClick.bind(this)
		this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
		this.handleClickCategory = this.handleClickCategory.bind(this)
		this.handleError = this.handleError.bind(this)
	}

	getCategorys() {
		return new Promise((resolve, reject) => {
			let xhr = new XMLHttpRequest()
			xhr.open("GET", config.restApiHost + `/inventory/categorys?sid=${Cookie.get("sid")}`, true)
			xhr.onreadystatechange = ()=>{
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve(JSON.parse(xhr.responseText))
					} else {
						reject("Не удалось получить список категорий")
					}
				}
			}
			xhr.send()
		})
	}

	componentDidMount() {
		this.getCategorys().then(categorys => {
			this.setState({
				selected: undefined,
				categorys: categorys,
			})
		}, this.handleError)
	}

	handleSelectButtonClick(e) {
		e.stopPropagation()
		if (typeof this.props.onSelectCategory === "function") {
			this.props.onSelectCategory(this.props.selected)
		}
	}

	handleError(errorMessage) {
		this.setState({
			dialog: <ErrorMessageDialog
				message = {errorMessage}
				onClose = {this.props.onCancel}
			/>
		})
	}

	handleCancelButtonClick(e) {
		e.stopPropagation()
		if (typeof this.props.onCancel === "function") {
			this.props.onCancel()
		}
	}

	handleClickCategory(category) {
		if (this.state.selected ? (this.state.selected.id === category.id) : false) {
			if (category.type === "0") { // dbl click folder
				category.expand = !category.expand
				this.forceUpdate()
			} else { // dbl click category
				if (typeof this.props.onSelectCategory === "function") {
					this.props.onSelectCategory(category)
				}
			}
		} else {
			this.setState({
				selected: category
			})
		}
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Выбор категории
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>

				<TreeList
					items = {this.state.categorys}
					selected = {this.state.selected}
					onClickItem = {this.handleClickCategory}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {this.state.selected ? this.state.selected.type !== "1" : true}
					onClick = {this.handleSelectButtonClick}
				>Выбрать</Button>

				<Button
					onClick = {this.handleCancelButtonClick}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default SelectCategoryDialog
